import {getUserInfo,messageList } from "@/api/modules/user";
import {getUserStatistics} from "@/api/modules/common";

const state = {
    isLogin: localStorage.getItem('isLogin') || false,  //登录状态
    userInfo: (() => {
        const stored = localStorage.getItem('userInfo');
        try {
            return stored ? JSON.parse(stored) : {};
        } catch (e) {
            console.warn('解析 userInfo 失败，使用默认值:', e);
            return {};
        }
    })(), //用户信息
    role: localStorage.getItem('role') || "",  //角色
    token: localStorage.getItem('token') || "", //token
    is_check: localStorage.getItem('is_check') || '', //审核状态
    is_vip: localStorage.getItem('is_vip') || false, //会员状态
    vip_level: localStorage.getItem('vip_level') || '', //VIP等级：vip或svip
    user_message_count: (() => {
        const stored = localStorage.getItem('user_message_count');
        try {
            return stored ? JSON.parse(stored) : 0;
        } catch (e) {
            console.warn('解析 user_message_count 失败，使用默认值:', e);
            return 0;
        }
    })(), //消息数量
    user_count: (() => {
        const stored = localStorage.getItem('user_count');
        try {
            return stored ? JSON.parse(stored) : {};
        } catch (e) {
            console.warn('解析 user_count 失败，使用默认值:', e);
            return {};
        }
    })(), //用户统计
    userStatisticsLoading: false, // 用户统计加载状态
}

const mutations = {
    //设置登录状态
    SET_LOGIN(state, isLogin) {
        state.isLogin = isLogin;
        localStorage.setItem('isLogin', state.isLogin);
    },
    //设置登录状态
    SET_VIP(state, is_vip) {
        state.is_vip = is_vip;
        localStorage.setItem('is_vip', state.is_vip);
    },
    //设置VIP等级
    SET_VIP_LEVEL(state, vip_level) {
        state.vip_level = vip_level;
        localStorage.setItem('vip_level', state.vip_level);
    },
    //设置用户信息
    SET_USERINFO(state, userInfo) {
        state.userInfo = userInfo;
        localStorage.setItem('userInfo', JSON.stringify(state.userInfo));
    },
    //设置角色
    SET_ROLE(state, role) {
        state.role = role;
        localStorage.setItem('role', state.role);
    },
    //设置token
    SET_TOKEN(state, token) {
        state.token = token;
        localStorage.setItem('token', token);
    },
    //设置审核状态
    SET_IS_CHECK(state, is_check) {
        state.is_check = is_check;
        localStorage.setItem('is_check', is_check);
    },
    //设置用户统计
    SET_USER_COUNT(state, count) {
        state.user_count = count;
        localStorage.setItem('user_count', JSON.stringify(count));
    },
    //设置用户统计加载状态
    SET_USER_STATISTICS_LOADING(state, loading) {
        state.userStatisticsLoading = loading;
    },
    SET_USER_MESSAGE_COUNT(state, count) {
        state.user_message_count = count;
        localStorage.setItem('user_message_count', JSON.stringify(count));
    }
}

const actions = {
    // 获取用户统计数据
    async GET_USER_COUNT({commit}) {
        try {
            commit('SET_USER_STATISTICS_LOADING', true);
            const res = await getUserStatistics();
            if (res.data && res.data.data) {
                commit('SET_USER_COUNT', res.data.data);
            } else {
                console.warn('用户统计数据格式异常:', res);
                commit('SET_USER_COUNT', {});
            }
        } catch (error) {
            console.error('获取用户统计数据失败:', error);
            commit('SET_USER_COUNT', {});
        } finally {
            commit('SET_USER_STATISTICS_LOADING', false);
        }
    },
    GET_USER_INFO({commit}) {
        getUserInfo().then((res) => {
            commit('SET_USERINFO', res.data.data);
            commit('SET_ROLE', res.data.data.role);
            commit('SET_IS_CHECK', res.data.data.is_check);
            commit('SET_LOGIN', true);
            commit('SET_VIP', res.data.data.vip_status == 1);
            // 设置VIP等级
            if (res.data.data.vip_status == 1) {
                commit('SET_VIP_LEVEL', res.data.data.vip_level || 'vip');
            } else {
                commit('SET_VIP_LEVEL', '');
            }
        });
    },
    GET_USER_MESSAGE_COUNT({commit}) {
        messageList({ page: 1, limit: 10 ,status:0}).then((res) => {
            this.total_count = res.data.data.total_count;
            let count = res.data.data.total_count-res.data.data.is_read_count
            commit('SET_USER_MESSAGE_COUNT', count);
        });
    }
}

export default {
    state,
    mutations,
    actions
}
